@if (!user()) {
  <app-header [user]="user()" />
}

<section class="www-pro-exp">
  <!-- <app-pro-experience-top /> -->
  <app-pillar-top
    [bannerUrl]="'assets/images/pages/home/pro-exp-banner.webp'"
    [bannerMobUrl]="'assets/images/pages/home/pro-exp-banner-mob.webp'"
  />
  <app-trainings-list [trainingType]="TrainingType.EVENT" />
  <app-newsletter-section />
</section>
